export default "__VITE_ASSET__B6JK_klc__"